import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e98cf6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col items-left pb-10" }
const _hoisted_2 = { class: "flex-1 truncate" }
const _hoisted_3 = { class: "text-gray-600 text-2xl font-bold truncate font-ammocorps" }
const _hoisted_4 = { class: "-mt-1 mb-3 text-gray-500 text-lg truncate" }
const _hoisted_5 = { class: "border-t border-b py-2 h-12 overflow-hidden" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-center my-4 py-4 rounded font-light" }
const _hoisted_8 = { class: "text-6xl text-gray-600 align-middle mr-3" }
const _hoisted_9 = { class: "button-group flex items-center relative p-4 space-x-2" }
const _hoisted_10 = { class: "flex border-t" }
const _hoisted_11 = {
  key: 0,
  class: "relative flex-1 mt-4 text-sm text-gray-700 font-medium"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pr-2 absolute -top-8 left-0 mt-1 text-gray-400 bg-white" }, "RECENT ACTIVITY", -1))
const _hoisted_13 = { class: "font-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowSmallUpIcon = _resolveComponent("ArrowSmallUpIcon")!
  const _component_ArrowSmallDownIcon = _resolveComponent("ArrowSmallDownIcon")!
  const _component_BuyButton = _resolveComponent("BuyButton")!
  const _component_SellButton = _resolveComponent("SellButton")!
  const _component_ShipButton = _resolveComponent("ShipButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: `/commodities/${_ctx.id}`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["record-box bg-white rounded-lg shadow border border-gray-300 p-5", {ignore: _ctx.isHoveredOverBrand}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.caliber.name), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.grade.name) + " Grade", 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
              return (_openBlock(), _createElementBlock("span", null, [
                _createElementVNode("img", {
                  src: `/${_ctx.appId}/brand-icons/${product.brandId}.svg`,
                  class: "brand-icon inline mr-1 h-8 mb-2 border rounded border-transparent"
                }, null, 8, _hoisted_6)
              ]))
            }), 256))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.price + '¢'), 1),
            _createElementVNode("span", {
              class: "text-lg align-middle",
              style: _normalizeStyle({ color: _ctx.priceDiffColor })
            }, [
              _createTextVNode(_toDisplayString(_ctx.priceDiff) + "¢ ", 1),
              (_ctx.priceDiff > 0)
                ? (_openBlock(), _createBlock(_component_ArrowSmallUpIcon, {
                    key: 0,
                    class: "inline h-6 text-green-500 -ml-2 -mt-0.5"
                  }))
                : (_ctx.priceDiff < 0)
                  ? (_openBlock(), _createBlock(_component_ArrowSmallDownIcon, {
                      key: 1,
                      class: "inline h-6 text-red-500 -ml-2 -mt-0.5"
                    }))
                  : _createCommentVNode("", true)
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_BuyButton, {
              class: "w-1/3",
              onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isHoveredOverBrand = true)),
              onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isHoveredOverBrand = false)),
              commodityId: _ctx.commodityId,
              price: _ctx.marketSummary.sellPrice,
              alignTo: _ctx.alignTo
            }, null, 8, ["commodityId", "price", "alignTo"]),
            _createVNode(_component_SellButton, {
              class: "w-1/3",
              onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isHoveredOverBrand = true)),
              onMouseout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isHoveredOverBrand = false)),
              commodityId: _ctx.commodityId,
              price: _ctx.marketSummary.buyPrice > 1 ? _ctx.marketSummary.buyPrice : _ctx.marketSummary.sellPrice,
              roundsOwned: _ctx.roundsOwned,
              alignTo: _ctx.alignTo
            }, null, 8, ["commodityId", "price", "roundsOwned", "alignTo"]),
            _createVNode(_component_ShipButton, {
              class: "w-1/3",
              roundsOwned: _ctx.roundsOwned,
              alignTo: _ctx.alignTo,
              commodityId: _ctx.commodityId
            }, null, 8, ["roundsOwned", "alignTo", "commodityId"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.lastOrderBought?.rounds)
            ? (_openBlock(), _createElementBlock("a", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", {
                  class: _normalizeClass(["last-order-wrapper rounded", { isVisible: _ctx.lastOrderVisible, isHidden: !_ctx.lastOrderVisible }])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["last-order-text py-1 font-bold", { isVisible: _ctx.lastOrderVisible, isHidden: !_ctx.lastOrderVisible }])
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.addCommas(_ctx.lastOrderBought.rounds)) + " rounds ", 1),
                    _createElementVNode("span", _hoisted_13, "traded " + _toDisplayString(_ctx.lastOrderBoughtAt) + " for ", 1),
                    _createTextVNode(_toDisplayString(_ctx.lastOrderPrice + '¢'), 1)
                  ], 2)
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["to"]))
}